import React, { useRef } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import TagForm from 'Components/SingleProject/Forms/TagForm';

export default function EditTagModal({
  open,
  tag,
  handleClose,
  handleSubmit,
  transitionDuration = 220,
  fetchTagsExtended,
  extendedTagsFetched,
  tagsFetching,
}) {
  const tagFormRef = useRef(null);

  return (
    <div>
      <Dialog
        open={open}
        transitionDuration={transitionDuration}
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            p: 1,
            pb: 2,
            justifyContent: 'center',
            alignItems: 'center',
            width: '440px',
          },
        }}
      >
        <DialogTitle>Update "{tag[0]?.tag}"</DialogTitle>
        <DialogContent>
          <TagForm
            tag={tag[0]}
            ref={tagFormRef}
            onSubmit={(values) => handleSubmit(values)}
            fetchTagsExtended={fetchTagsExtended}
            extendedTagsFetched={extendedTagsFetched}
            tagsFetching={tagsFetching}
          />
        </DialogContent>
        <DialogActions
          style={{ justifyContent: 'space-between', width: '60%' }}
        >
          <Button
            style={{ width: '100%', marginRight: '8px' }}
            variant="outlined"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            style={{ width: '100%' }}
            variant="contained"
            onClick={() => tagFormRef.current?.requestSubmit()}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
